"use strict";
/****************************************************
 * Audit Information Platform Component
 * Message 提示组件
 * 2020-08
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
//----- iUAP ------
var tinper_bee_1 = require("tinper-bee");
var Const_1 = require("./Const");
/**
 * 消息封装组件
 *
 */
var Message = /** @class */ (function () {
    function Message() {
    }
    /**
     * 显示消息提示对话框
     *
     * @param {string}  message 消息内容
     * @param {string} color 主题色 [dark/light/success/danger/warning/info/successlight/dangerlight/warninglight/infolight]
     * @param {number} sec 显示停留时间(单位s)
     */
    Message.showMessage = function (message, color, sec) {
        if (!message)
            message = Const_1.UNKNOWN_ERROR_MSG;
        tinper_bee_1.Message.destroy();
        tinper_bee_1.Message.create({
            content: message,
            color: color || "dark",
            duration: sec || 5,
        });
    };
    /**
     * 显示错误对话框
     *
     * @param {string} message 消息内容
     * @param {number} sec 显示停留时间(单位s)
     */
    Message.showErrorMessage = function (message, sec) {
        Message.showMessage(message, "dangerlight", sec);
    };
    /**
     * 显示确认对话框
     * @param {string} title 标题
     * @param {string} content 内容
     * @param {Function} okFn 点击确认触发
     * @param {Function} cancelFn 点击取消触发
     */
    Message.confirm = function (title, content, okFn, cancelFn) {
        tinper_bee_1.Modal.confirm({
            title: title,
            content: content,
            onOk: function () {
                okFn && okFn();
            },
            onCancel: function () {
                cancelFn && cancelFn();
            },
        });
    };
    return Message;
}());
exports.default = Message;
